import { render } from "./EnumSelect.vue?vue&type=template&id=2e24ae18"
import script from "./EnumSelect.vue?vue&type=script&lang=ts"
export * from "./EnumSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script